import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';

import type { UpdateAssistSettings } from '../@types/user';
import { UPDATE_ASSIST_SETTINGS } from '../modules/login/login.constants';
import { makeAPIRequestV2 } from '../utils/api';

export const useUpdateAssistSettings = () => {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: async (updateAssistSettingsBody: UpdateAssistSettings) => {
      await makeAPIRequestV2(
        `/user/assistSettings`,
        { data: updateAssistSettingsBody },
        'PATCH',
      );
      return updateAssistSettingsBody;
    },
    onSuccess: (data) => {
      dispatch({
        type: UPDATE_ASSIST_SETTINGS,
        data: {
          privacyOn: data.privacyOn,
          patientListView: data.patientListView,
        },
      });
    },
  });
};
